import "./Congratulations.scss";

import { Box, Card, Link, Typography } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { ContentWrapper } from "components/ContentWrapper";
import Navbar from "components/Navbar";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

export const Congratulations = () => {
  // Hooks
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <Box>
      <Navbar />

      <ContentWrapper>
        <Box className="congratulations">
          <Card className={"card"}>
            <Box className="grid-container">
              <CheckCircleIcon className="icon--big" />

              <Typography className="title--centered--isolated">{t("Congratulations")}</Typography>

              <Typography className="subtitle--centered">
                {t("Your subscription process is now complete.")}
                <br/>
                {t("We will keep you informed by e-mail and via the investor portal.")}
              </Typography>

              <Typography className="subtitle--centered subtitle--bold">{t("Thank you for your trust.")}</Typography>

              <Typography className="subtitle--centered">
                <Link className="link" onClick={() => history.goBack()}>
                  {t("Back to products")}
                </Link>
              </Typography>
            </Box>
          </Card>
        </Box>
      </ContentWrapper>
    </Box>
  );
};
